export default "__VITE_ASSET__BTPN$yLF__"